export {default} from '../../../core/components/Repository/PageDetail';